// Generated by Melange

import * as Buhta_cabinet__Data from "../core/Data.js";
import * as Buhta_cabinet__Kassa from "../grpc/Kassa.js";
import * as Buhta_cabinet__ReceiptBody from "../components/organisms/Kassa/KKM/ReceiptBody.js";
import * as Buhta_components__Text from "../../../../packages/components/src/html/Text.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function ReceiptPage(Props) {
  let kkm = Props.kkm;
  let id = Props.id;
  const match = Buhta_cabinet__Data.Context.useData(undefined);
  const dispatchData = match[1];
  const firstTime = React.useRef(true);
  const receipt = match[0].receipt;
  React.useEffect((function () {
    if (!firstTime.current || receipt.id === "") {
      const __x = Buhta_cabinet__Kassa.ReceiptService.view(undefined, kkm, /* [] */ 0, id, undefined);
      $$Promise.getOk(__x, (function (data) {
        Curry._1(dispatchData, {
          TAG: /* Receipt */ 0,
          _0: data
        });
      }));
      firstTime.current = false;
    }
    
  }), [
    kkm,
    id
  ]);
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("a", {
        children: JsxRuntime.jsx("img", {
          className: "h-6 md:h-7",
          src: StaticAsset.src("/static/icons/logo-black.svg")
        }),
        className: "mt-6 md:mt-10",
        href: "https://buhta.com"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_components__Text.H4.make, {
            className: "px-6 py-4",
            children: "Чек №" + String(receipt.serial_id)
          }),
          JsxRuntime.jsx("hr", {}),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Buhta_cabinet__ReceiptBody.make, {
              receipt: receipt
            }),
            className: "p-6"
          })
        ],
        className: "w-full md:w-112 bg-white mt-6 md:mt-10 rounded-md shadow-card"
      }),
      JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
        className: "mt-6 text-default-gray",
        children: "© 2014-2024 Бухта"
      })
    ],
    className: "bg-gray-pale h-screen flex flex-col items-center font-hauss pb-6 md:pb-14 px-4 overflow-y-auto"
  });
}

const make = ReceiptPage;

export {
  make,
}
/* Buhta_cabinet__Data Not a pure module */
